import { createReducer, on } from '@ngrx/store';

import { NoteActions } from './note.actions';
import { NoteState } from './note.state';

export const initNoteState: NoteState = {
  note: '',
  installationId: '',
  loading: false,
  loaded: false,
  error: null,
};

export const noteReducer = createReducer(
  initNoteState,
  on(
    NoteActions.addNote,
    (state, { installationId, note }): NoteState => ({
      ...state,
      installationId,
      note,
      loading: true,
      loaded: false,
      error: null,
    })
  ),
  on(
    NoteActions.addNoteSuccess,
    (state): NoteState => ({
      ...state,
      loading: false,
      loaded: true,
      error: null,
    })
  ),
  on(
    NoteActions.addNoteError,
    (state, { error }): NoteState => ({
      ...state,
      note: '',
      loading: false,
      loaded: true,
      error,
    })
  ),
  on(
    NoteActions.deleteNote,
    (state, { installationId }): NoteState => ({
      ...state,
      installationId,
      loading: true,
      loaded: false,
      error: null,
    })
  ),
  on(
    NoteActions.deleteNoteSuccess,
    (state): NoteState => ({
      ...state,
      note: '',
      loading: false,
      loaded: true,
      error: null,
    })
  ),
  on(
    NoteActions.deleteNoteError,
    (state, { error }): NoteState => ({
      ...state,
      loading: false,
      loaded: true,
      error,
    })
  ),
  on(
    NoteActions.getNote,
    (state, { installationId }): NoteState => ({
      ...state,
      note: '',
      installationId,
      loading: true,
      loaded: false,
      error: null,
    })
  ),
  on(
    NoteActions.getNoteSuccess,
    (state, { note }): NoteState => ({
      ...state,
      note,
      loading: false,
      loaded: true,
      error: null,
    })
  ),
  on(
    NoteActions.getNoteError,
    (state, { error }): NoteState => ({
      ...state,
      loading: false,
      loaded: true,
      error,
    })
  )
);
